import React, {useState, useEffect} from 'react';
import { useForm, Controller} from 'react-hook-form';
import Select from "react-select";
import { NumericFormat } from 'react-number-format';
import schedulePayService from '../../services/SchedulePayService';

export default function LayerEditCredit({show,onClose,onFetchPay,schedulePay}) {
    const { register, control, handleSubmit, reset,formState: { errors } } = useForm({});
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const closeSlide = () => {
        setErrorMsg("");
        setMessage("");
        onClose();
    };

    const handleActionPay= async (data) => {
        const taxableFormat = data.taxable && String(data.taxable).includes(',')
          ? data.taxable.replace(/\./g, '').replace(/,/g, '.').replace(/[^\d.-]/g, '')
          : data.taxable;
        const payload = {
            ...data,
            taxable: Number(taxableFormat)
        };

       schedulePayService.updateCredit(payload,reset)
            .then((res) => {
                setMessage("Nota di credito aggiornata con successo!");
                setErrorMsg("");
                onFetchPay();
            }).catch((error) => {
                console.error("Error update pay: ", error);
                setMessage("");
                setErrorMsg("Errore aggiornamento nota di credito. Riprova.");
            }
        );
    }

    useEffect(() => {
        reset({
            ...schedulePay
        });
    }, [schedulePay, reset]);

  	return (
  	    <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">Modifica Nota di credito del contratto {schedulePay ? schedulePay.numberContract.toString().padStart(3, "0") : ""}</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                <form className="add-new-user pt-0" onSubmit={handleSubmit(handleActionPay)}>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Numero*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.invoice ? "is-invalid" : ""}`}>
                                    <i className="bx bx-barcode" ></i>
                                </span>
                                <Controller
                                    control={control}
                                    name="invoice"
                                    rules={{
                                        required: 'Richiesto',
                                        maxLength: {
                                            value: 100,
                                            message: 'Massimo 100 caratteri'
                                        }
                                    }}
                                    render={({ field }) => (
                                        <input
                                          {...field}
                                          type="text"
                                          className={`form-control ${errors.invoice ? "is-invalid" : ""}`}
                                        />
                                    )}
                                />
                            </div>
                            {errors.invoice && <div className="invalid-input">{errors.invoice.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Data*</label>
                            <input className={`form-control ${errors.invoice_date ? "is-invalid" : ""}`}
                                type="date"
                                placeholder={`${errors.invoiceDate ? errors.invoiceDate.message : ""}`}
                                {...register('invoiceDate',
                                    {
                                        required: 'Richiesto',
                                    }
                                )}
                             />
                            {errors.invoiceDate && <div className="invalid-input">{errors.invoiceDate.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Importo*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.taxable ? "is-invalid" : ""}`}>
                                    <i className="bx bx-euro" ></i>
                                </span>
                                <Controller
                                    name="taxable"
                                    control={control}
                                    rules={{ required: 'Richiesto' }}
                                    render={({ field }) => (
                                        <NumericFormat
                                            {...field}
                                            className={`form-control ${errors.taxable ? "is-invalid" : ""}`}
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            allowNegative={false}
                                        />
                                    )}
                                />
                            </div>
                            {errors.taxable && <div className="invalid-input">{errors.taxable.message}</div>}
                        </div>
                        <div className="col-3 mb-6">
                            <label className="form-label">Iva</label>
                            <select className={`form-select ${errors.iva ? "is-invalid" : ""}`}
                                type="text"
                                placeholder="Seleziona uno stato"
                                {...register('iva', { required: 'Richiesto' })}
                            >
                                <option value="true">Si</option>
                                <option value="false">No</option>
                            </select>
                            {errors.iva && <div className="invalid-input">{errors.iva.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Note</label>
                            <Controller
                                control={control}
                                name="note"
                                rules={{
                                    maxLength: {
                                        value: 512,
                                        message: 'Massimo 512 caratteri'
                                    }
                                }}
                                render={({ field }) => (
                                    <textarea
                                        {...field}
                                        placeholder="Aggiungi una nota..."
                                        className={`form-control ${errors.note ? "is-invalid" : ""}`}
                                        rows="4"
                                    />
                                )}
                            />
                            {errors.note && <div className="invalid-input">{errors.note.message}</div>}
                        </div>
                    </div>
                    <button type="submit" className="btn btn-primary me-3">Invia</button>
                </form>
            </div>
  	    </div>
	);
}